<!-- git/truth-first-look/src/pages/Dashboard.tsx MobileNavButton row -->
<nav class="md:hidden fixed bottom-0 left-0 right-0 bg-card/95 backdrop-blur-md border-t border-border flex items-center justify-around px-2 py-2 z-50" aria-label="Mobile">
  <button
    *ngFor="let item of items"
    type="button"
    class="relative p-2.5 rounded-full transition-colors"
    [ngClass]="item.active ? 'text-foreground' : 'text-muted-foreground'">
    <ng-container [ngSwitch]="item.icon">
      <svg *ngSwitchCase="'home'" width="24" height="24" viewBox="0 0 24 24" [attr.fill]="item.active ? 'currentColor' : 'none'" stroke="currentColor" stroke-width="1.75">
        <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" />
        <polyline points="9 22 9 12 15 12 15 22" />
      </svg>
      <svg *ngSwitchCase="'explore'" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75">
        <circle cx="12" cy="12" r="10" />
        <polygon points="16.24 7.76 14.12 14.12 7.76 16.24 9.88 9.88 16.24 7.76" />
      </svg>
      <svg *ngSwitchCase="'notifications'" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75">
        <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9" />
        <path d="M13.73 21a2 2 0 0 1-3.46 0" />
      </svg>
      <svg *ngSwitchCase="'messages'" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75">
        <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
        <polyline points="22,6 12,13 2,6" />
      </svg>
      <svg *ngSwitchCase="'profile'" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75">
        <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
        <circle cx="12" cy="7" r="4" />
      </svg>
    </ng-container>
    <span *ngIf="item.badge != null && item.badge > 0" class="absolute top-1 right-1 min-w-[16px] h-[16px] flex items-center justify-center rounded-full bg-ts-red text-[9px] font-bold text-white px-0.5">
      {{ item.badge }}
    </span>
  </button>
</nav>
